import { render } from "./BloodStatusPublic.vue?vue&type=template&id=ecb64b8e&scoped=true"
import script from "./BloodStatusPublic.vue?vue&type=script&lang=js"
export * from "./BloodStatusPublic.vue?vue&type=script&lang=js"

import "./BloodStatusPublic.vue?vue&type=style&index=0&id=ecb64b8e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb64b8e"]])

export default __exports__